<template>
    <div class="modal" tabindex="-1" role="dialog" style="display: block">
        <div class="modal-dialog" role="document" style="position: relative">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">
                        Edit Resource
                    </h4>
                </div>
                <div v-if="statusMessage" :class="['alert', 'alert-dismissible', (statusMessage.type == 'error') ? 'alert-danger' : 'alert-info']">
                    <span class="close" aria-label="close" v-on:click="statusMessage = null">&times;</span>
                    <p v-text="statusMessage.text"></p>
                </div>
                <div class="modal-body">
                    <div class="form-group" v-if="isUserSysOp">
                        <label for="frm-name">Name</label>
                        <input type="tel" name="name" class="form-control" v-model="key" placeholder="Enter Resource Name">
                    </div>
                    <div class="form-group" v-if="isUserSysOp">
                        <label for="frm-name">Type</label>
                        <select v-model="type" @change="onTypeChanged" class="form-control">
                            <option value="text">Text</option>
                            <option value="multi-text">Multi Text</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="frm-name">Content</label>
                        <div v-if="isMultiText" style="overflow-y: auto; max-height: 400px">
                            <div v-for="(valueText, index) in content" style="position: relative;">
                                <rich-text-area  :value="valueText" @input="onMultiTextChanged(index, $event)" style="width: 100%; min-height: 100px; padding-right: 40px;" />
                                <span v-if="isUserSysOp" class="fas fa-trash btn" v-on:click="onDeleteMultiText(index)" style="position: absolute; top: 5px; right: 10px"></span>
                            </div>
                        </div>
                        <div v-else>
                            <rich-text-area v-model="content" style="width: 100%; min-height: 100px;" />
                        </div>
                    </div>
                    <div>
                        <button v-show="isMultiText" type="button" @click="onAddText" class="btn">Add Text</button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn" data-dismiss="modal" @click="$emit('cancel')">Cancel</button>
                    <button type="submit" class="btn btn-danger" @click="onSave">
                        <span class="glyphicon glyphicon-save" aria-hidden="true"></span> Save
                    </button>
                </div>
            </div>
            <div v-show="isBusy" class="loader-overlay">
                <div class="loader"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            value: Object,
            addUpdateUrl: String,
            isUserSysOp: Boolean
        },
        name: "resources-dictionary-edit-modal",
        computed:{
            isMultiText(){
                return this.type == 'multi-text';
            }
        },
        data() {
            return {
                statusMessage: null,
                localValue: null,
                isBusy: false,
                content: '',
                key: null,
                type: 'text'
            };
        },
        methods:{
            onAddText(){
                if(!this.content){
                    this.content = [];
                }
                this.content.push('');
            },
            onSave(){
                if(!this.key || !this.type || !this.value){
                    this.showError('Please fill all fields.');
                    return null;
                }
                this.isBusy = true;
                var item = _.cloneDeep(this.value);
                item.prevKey = this.value.key;
                item.key = this.key;
                item.type = this.type;
                item.value = this.content;
                return axios.post(this.addUpdateUrl, item)
                    .then((response) => {
                        if(!response.data.key) {
                            this.showError('We cannot save data, please try again later.');
                            return;
                        }
                        this.isBusy = false;
                        this.$emit('save', { item: response.data, prevKey: item.prevKey});
                    })
                    .catch(() => {
                        this.showError('We cannot save data, please try again later.');
                    })
                    .finally(()=> {this.$emit('is-busy', false)});
            },
            onTypeChanged(){
                if(this.type == 'multi-text'){
                    this.content = [this.content || ''];
                }
                else if(this.type == 'text'){
                    this.content =  (typeof this.content == 'string') ? this.content : _.get(this.content, '[0]', '');
                }
            },
            onMultiTextChanged(index, value){
                this.content.splice(index, 1, value);
            },
            onDeleteMultiText(index){
                this.content.splice(index, 1);
            },
            showError(message){
                this.statusMessage = {
                    type: 'error',
                    text: message
                }
            },

        },
        watch: {
            value(){
                if(!this.value){
                    return;
                }
                this.key = this.value.key;
                this.type = this.value.type;
                this.content = _.cloneDeep(this.value.value);
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

    .loader-overlay{
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 99999999;
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }
    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -2.2em;
        margin-left: -2.2em;
    }
</style>